import * as React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import UpgradeRoundedIcon from "@mui/icons-material/UpgradeRounded";

export default function TooltipShow ({ icon, title, data, operation, onSubmit }) {
  return (
    <Tooltip title={title} onClick={() => onSubmit(data, operation)}>
      <IconButton style={{ fontSize: "20px" }}>{icon}</IconButton>
    </Tooltip>
  );
}
